import { getConfig } from '../data/config';

export function determineAppMode(): 'default' | 'b2b' {
  const currentHost = window.location.hostname;
  const config = getConfig();

  return currentHost === config.b2bFrontendHost ? 'b2b' : 'default';
}
